(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bold-night-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bold-arrivals')) {
    customElements.define('bold-arrivals', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.bold-arrivals__list');
        this.buttons = [...this.querySelectorAll('button[data-direction]')];
        this.update = () => {
          this.buttons[0].disabled = this.list.scrollLeft <= 1;
          this.buttons[1].disabled = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 2;
        };
        this.move = (event) => {
          const button = event.target.closest('button[data-direction]');
          if (!button) return;
          this.list.scrollBy({left: Number(button.dataset.direction) * this.list.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        this.addEventListener('click', this.move);
        this.list.addEventListener('scroll', this.update, {passive:true});
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.list);
        this.update();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.move);
        this.list.removeEventListener('scroll', this.update);
        this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
